<template>
  <div class="main-header">
    <img class="main-title" :src="ImgMainTitle" alt="main-title" />
    <div class="main-rule" :class="locale">
      {{ $t('monopoly.mainRule') }}
    </div>
    <div class="login" v-if="!isLoggedIn" @click="openLoginDialog">
      <div class="login-btn">
        {{ $t('monopoly.login.logintxt') }}
      </div>
    </div>
    <div class="user-info" v-else>
      <div class="uid">
        {{ actUserInfo.uid }}
      </div>
      <div class="logout-btn" @click="handleLogout">
        {{ $t('monopoly.logout') }}
      </div>
    </div>
    <div class="opt-btns">
      <div class="opt-btn yellow" @click="ruleDialogVisible = true">
        {{ $t('monopoly.rule') }}
      </div>
      <div class="opt-btn blue" @click="openRewardRecordDialog">
        {{ $t('monopoly.rewardRecord') }}
      </div>
    </div>
    <Dialog v-model="ruleDialogVisible" :title="$t('monopoly.rule')">
      <div class="rule-content">
        {{ $t('monopoly.ruleContent') }}
      </div>
    </Dialog>
    <RewardRecordDialog v-model="rewardRecordDialogVisible" />
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import Dialog from '../Dialog/index.vue'
import RewardRecordDialog from '../RewardRecordDialog/index.vue'
import ImgMainTitleMap from '@/views/act/monopoly/assets/img/main-title/index.js'

const store = useStore()
const { locale } = useI18n()
const openMonopolyLogin = inject('openMonopolyLogin', () => {})

const ImgMainTitle = computed(() => ImgMainTitleMap[locale.value])
const actUserInfo = computed(() => store.state.actUserInfo || {})
const isLoggedIn = computed(() => !!actUserInfo.value.token)

const ruleDialogVisible = ref(false)
const rewardRecordDialogVisible = ref(false)

const openLoginDialog = () => {
  openMonopolyLogin()
}

const openRewardRecordDialog = () => {
  if (!isLoggedIn.value) {
    openMonopolyLogin()
    return
  }
  rewardRecordDialogVisible.value = true
}

const handleLogout = () => {
  store.commit('SET_ACT_USER_INFO', {})
}
</script>

<style lang="less" scoped>
.main-header {
  .main-title {
    width: 680px;
    height: 215px;
    margin: 0 auto;
    display: block;
    margin-top: 80px;
    object-fit: contain;
  }
  .main-rule {
    width: 710px;
    background: url('~@/views/act/monopoly/assets/img/main-rule-bg.png') center center / 100% 100% no-repeat;
    padding: 15px;
    font-size: 24px;
    line-height: 1.4;
    color: #FFFFFF;
    margin: 0 auto;
    margin-top: 20px;
    white-space: pre-line;
    &.vi {
      font-size: 20px;
    }
    &.en, &.sg, &.my, &.ph, &.in {
      font-size: 20px;
    }
    &.id {
      font-size: 20px;
    }
  }

  .login, .user-info {
    font-size: 24px;
    color: #12215C;
    text-align: center;
    margin-top: 16px;
  }

  .login-btn,
  .logout-btn {
    cursor: pointer;
  }

  .uid {
    margin-bottom: 8px;
  }

  .opt-btns {
    display: flex;
    justify-content: center;
    gap: 35px;
    margin-top: 30px;
    .opt-btn {
      min-width: 250px;
      height: 60px;
      border-radius: 30px;
      background-image: linear-gradient(to bottom, #FEDF6B, #EB8D22);
      border: 3px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      font-weight: bold;
      font-size: 26px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      &.blue {
        background-image: linear-gradient(to bottom, #64DDFD, #2EAFEC);
      }
    }
  }
}

.rule-content {
  width: 100%;
  box-sizing: border-box;
  font-size: 24px;
  line-height: 1.6;
  color: #12215C;
  white-space: pre-line;
  text-align: left;
  padding-bottom: 8px;
}
</style>
